/** Polling interval for live billing data (30 seconds) */
export const LIVE_BILL_POLL_MS = 30_000

/** Polling interval for wallet balance refresh (60 seconds) */
export const WALLET_BALANCE_POLL_MS = 60_000
